import React from 'react'
import styled from 'styled-components'

import AboutMainTopImage from '../../atoms/AboutMainTopImage'
import AboutMainInfo from '../../atoms/AboutMainInfo'

export default () => {
  return (
    <Container>
      <AboutMainTopImage/>
      <AboutMainInfo/>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 50vh;
  background-color: ${props => props.theme.green};
  @media(min-width: 900px) {
    width: 80%;
    margin: 0 auto;
    height: 40vh;
  }
  @media(min-width: 1100px) {
    width: 80%;
    margin: 0 auto;
    height: 35vh;
  }
  @media(min-width: 1300px) {
    width: 70%;
    margin: 0 auto;
    height: 35vh;
    display: flex;
    justify-content: flex-end;
    top: -3rem;
  }
`